<pw-app-layout #layout [layoutMode]="'default'">
  <pw-menu-container>
    <mat-nav-list class="app-menu">
      <mat-list-item routerLink="/redirect" (click)="toggleSidenav()">
        <mat-icon matListItemAvatar>home</mat-icon>
        <span matListItemLine>Home</span>
      </mat-list-item>
      <mat-list-item *ngIf="clientAuth.isAuthenticated$ | async" routerLink="/orders" (click)="toggleSidenav()">
        <mat-icon matListItemAvatar>assignment</mat-icon>
        <span matListItemLine>{{'app.appMenu.orders' | translate}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="clientAuth.isAuthenticated$ | async" routerLink="/scan" (click)="toggleSidenav()">
        <mat-icon matListItemAvatar>qr_code_scanner</mat-icon>
        <span matListItemLine>{{'app.appMenu.scanner' | translate}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="clientAuth.isAuthenticated$ | async" routerLink="/pm-constructions" (click)="toggleSidenav()">
        <mat-icon matListItemAvatar>change_circle</mat-icon>
        <span matListItemLine>{{'app.appMenu.changeManagement' | translate}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="clientAuth.isAuthenticated$ |async" routerLink="/suppliers" (click)="toggleSidenav()">
        <mat-icon matListItemAvatar>contacts</mat-icon>
        <span matListItemLine>{{'app.appMenu.contacts' | translate}}
      </span>
      </mat-list-item>
    </mat-nav-list>

    <div style="padding: 10px" class="app-logo-container">
      <img class="app-logo" src="./assets/icons/tebis_logo.svg"/>
      <div class="mat-body-2">ProLeiS Lieferantenapp</div>
      <div class="mat-body-2">4.0-20</div>
    </div>
  </pw-menu-container>
</pw-app-layout>
